import Api from 'src/api/Base'

class GetChangeControlSummaryById extends Api {
  requestUrl = `/api/ChangeControl/Summary/${this.getParams().id}`
}
export default GetChangeControlSummaryById
